import { Injectable } from '@angular/core';
import { Firestore, deleteDoc, collectionData, collection, addDoc, query, where, getDocs, doc, setDoc } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { IUser } from 'src/app/model/user';
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  

  constructor(public firestore: Firestore) { }


  /**
   * 
   * @param data 
   * @returns 
   */
  preRegistration(user: IUser) {
    return new Observable(observer =>{
      this.isUserExists(user).then(async result =>{
        if(!result){
          const etudiantRef = doc(this.firestore, `Etudiants/${user.email}`);
          setDoc(etudiantRef, user).then(() =>{
            console.log()
            observer.next(true);
          },(error) => {
            console.error("Erreur lors de l'écriture :", error);
          });
        }
        else{
          observer.error(result)
        }
      })
    })


   
  }

  /**
   * 
   * @param data 
   * @returns 
   */
  async isUserExists(user: IUser): Promise<number> {
    const userCollection = collection(this.firestore, `Etudiants`);
    const q = query( userCollection , where("email", "==", user.email));
    const querySnapshot = await getDocs(q);
    return querySnapshot.size;
    // return collectionData(booksRef, { idField: 'email' }) as Observable<IUser[]>;
  }

    /**
   * 
   * @param data 
   * @returns 
   */
     async checkCode(code:string, email:string):Promise<any> {
      const userCollection = collection(this.firestore, `request-study`);
      const q = query( userCollection , where("email", "==", email));
      const querySnapshot = await getDocs(q);
      let codeChecked = false,data;
      querySnapshot.forEach((doc) => {
        codeChecked = doc.id === code;
        data = doc.data();
      });
      
      return new Promise<any>((resolve, reject)=>{
        resolve({check:codeChecked,data:data})
      });  
    }


    async checkEmailInUser(email:string) {
      const userCollection = collection(this.firestore, `users`);
      const q = query( userCollection , where("email", "==", email));
      const querySnapshot = await getDocs(q);
      return querySnapshot.size;
    }

    async writeUserData(user): Promise<any> {
      return addDoc(collection(this.firestore, 'users'),user);
  }


  deleteDocument(code: any): any {

    deleteDoc(doc(collection(this.firestore, 'request-study'
    ,'test'))).then(x=>{
    })
  }

}
